module.exports = __webpack_public_path__ + "img/library.9696273b.jpg";